import { FC, useEffect } from 'react';
import { AiReceptionistEventType } from '@weave/schema-gen-ts/dist/shared/phone/events/vair/v1/vair.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { AiEventsChecklistField } from '@frontend/phone-ui-widgets';
import { trackingIds } from '../../../../tracking-ids';
import { useVoiceAiLocations } from '../../hooks/use-voice-ai-locations';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const AiEventFilterTray: FC<{ showClear?: boolean; disabled?: boolean }> = ({ disabled, showClear = true }) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified } = useCallIntelFiltersContext();
  const { activeLocationIds: activeVoiceAiLocations, isLoading } = useVoiceAiLocations({
    locationIds: filterValues.locations ?? [],
  });

  useEffect(() => {
    updateFilterModified({ aiEvents: !!filterValues.aiEvents?.length });
  }, [filterValues.aiEvents, updateFilterModified]);

  const isDisabled = disabled || isLoading;

  if (!activeVoiceAiLocations.length) {
    return null;
  }

  return (
    <FilterTraySection
      label={t('AI Receptionist Outcomes')}
      showClear={showClear}
      disableClear={isDisabled}
      onClear={() => updateFilterValues({ aiEvents: [] })}
      icon={<Icon name='aiweave-assistant' size={16} opacity='0.75' />}
    >
      <AiEventsChecklistField
        selectedEvents={filterValues.aiEvents ?? []}
        onChange={(nextValue: AiReceptionistEventType[]) => updateFilterValues({ aiEvents: nextValue })}
        trackingId={trackingIds.callIntel.aiEventFilter}
        label={t('Select AI Receptionist Outcomes')}
      />
    </FilterTraySection>
  );
};
